import type {
  FsType,
  IxdChunk,
  IxdNoteChecklistFinding,
} from "@/apis/ixd-editor/types";
import type { DocumentSidebarCategory } from "@/components/document-sidebar";
import { isFinancialStatementChunkTitle } from "@/utils/ixd-editor/chunk-kind";

/**
 * 목차는 IXD 값 편집기와 같이 본문·주석 두 묶음. 넘겨받은 지적이 걸린 목차에 점을 찍는다
 * (지적을 고르면 그 지적만 넘겨, 그 지적이 어느 목차들에 걸쳤는지 보이게 한다).
 */
export const buildTocCategories = (
  chunks: IxdChunk[],
  fsType: FsType,
  findings: IxdNoteChecklistFinding[],
): DocumentSidebarCategory[] => {
  const flagged = new Set(
    findings.flatMap((f) => f.locations.map((l) => l.chunkId)),
  );
  // chunk title 에는 연결/별도 구분이 없어 본문 목차에만 붙인다 (편집기와 같은 표기)
  const prefix = fsType === "consolidated" ? "연결" : "별도";
  const toSection = (isStatement: boolean) =>
    chunks
      .filter((c) => isFinancialStatementChunkTitle(c.title) === isStatement)
      .map((chunk) => ({
        id: chunk.id,
        label: isStatement ? `${prefix}${chunk.title}` : chunk.title,
        hasChanges: flagged.has(chunk.id),
      }));
  return [
    { label: "본문", sections: toSection(true) },
    { label: "주석", sections: toSection(false) },
  ].filter((category) => category.sections.length > 0);
};
